import axios from '../axios';

function buildQuery (options = {}) {
  const params = {};

  if (options.service_area_id) {
    params.service_area_id = options.service_area_id;
  }

  if (options.agent_id) {
    params.agent_id = options.agent_id;
  }

  if (options.search) {
    params.search = options.search;
  }

  const query = [];
  for (const param in params) {
    query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
  }

  return query.length ? '?' + query.join('&') : '';
}

export default {
  getMtoSectors (options = {}) {
    return axios.get('/mto-sector' + buildQuery(options));
  },

  getMtoSector (id, options = {}) {
    return axios.get(`/mto-sector/${id}` + buildQuery(options));
  },

  createMtoSector (params) {
    return axios.post('/mto-sector', params);
  },

  updateMtoSector (id, data) {
    return axios.put(`/mto-sector/${id}`, data);
  },

  deleteMtoSector (id) {
    return axios.delete(`/mto-sector/${id}`);
  },

  importDoorphones (id, file) {
    const formData = new FormData();
    formData.append('file', file);

    return axios.post(`/mto-sector/${id}/import-doorphones`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  attachEquipment (id, data) {
    return axios.post(`/mto-sector/${id}/attach-equipment`, data);
  },

  detachEquipment (id, data) {
    return axios.post(`/mto-sector/${id}/detach-equipment`, data);
  },
};
